import React from 'react'

require('../style/css/third_party/foundation.css')
require('../style/css/third_party/animate.css')

require('../style/scss/custom/main.scss')

require('../style/css/custom/components/motionGraphics.css')
require('../style/css/custom/main.css')

require('../js_animations/customAnimations.js')
require('../js_animations/scrollMagic.js')


const MotionGraphics = () => (

<div className="motion-graphics" id="motion-graphics">

  <div className="wow animated slideInUp iframe-enclosure" data-wow-offset='400'>
    <iframe
      title="tpc_trailer"
      className="trailer"
      id="tpc_trailer"
      src="https://www.youtube.com/embed/lRH7Ztl5QCE?rel=0&amp;showinfo=0?ecver=1"
      frameBorder="0"
      allowFullScreen
      muted='true'
    ></iframe>
  </div>

  <div className="iframe-enclosure" data-wow-offset=''>
    <iframe
      title="stwof_trailer"
      className="trailer"
      id="stwof_trailer"
      src="https://www.youtube.com/embed/LChrPEfnNfc?rel=0&amp;showinfo=0?ecver=1"
      frameBorder="0"
      allowFullScreen
    ></iframe>

  </div>

  <div className="iframe-enclosure" data-wow-offset=''>
    <iframe
      title="cwmi_video"
      className="music-video"
      id="cwmi_video"
      src="https://www.youtube.com/embed/FXd1cu6KGV8?rel=0&amp;showinfo=0?ecver=1"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  </div>


</div>

// closes 'motion-graphics'


)

export default MotionGraphics



// WEBPACK FOOTER //
// ./src/components/motionGraphics.js